import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css'

ReactDOM.render(<App />, document.getElementById('root'));
// Ejector Seat
// ReactDOM.render((
//     <div className="app-content-wrap">
//         <div className="app-content">
//             <div className="page">
//                 <h1>Something has gone catastrophically wrong</h1>
//                 <p>Firesideometer's enormous team of highly skilled software engineers is scrambling to fix whatever the fuck is actually happening.</p>
//             </div>
//         </div>
//     </div>
// ), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
